import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Droplets, Wrench, Leaf, Briefcase } from "lucide-react";
export default function HighPressureAndStoneCleaningEnvironmentallyFriendly() {
  const services = [{
    title: "Flächenreinigung ohne chemische Zusätze",
    description: "Professionelle Reinigung von Terrassen, Einfahrten, Pflaster, Parkplätzen und Sportflächen – ausschließlich mit Wasser und moderner Hochdrucktechnik, umweltfreundlich und materialschonend.",
    icon: Droplets
  }, {
    title: "Hausmeistertätigkeiten",
    description: "Zuverlässiger Hausmeisterservice im nicht handwerkspflichtigen Bereich für die Pflege und Instandhaltung Ihrer Immobilien, Außenanlagen und Gemeinschaftsflächen.",
    icon: Wrench
  }, {
    title: "Gartenpflege",
    description: "Umfassende Gartenpflege mit Hecken- und Rasenschnitt, Strauchschnitt, Laubbeseitigung und saisonaler Pflege für gepflegte und attraktive Außenbereiche.",
    icon: Leaf
  }, {
    title: "Bürotätigkeiten und Organisation",
    description: "Professionelle Unterstützung bei Bürotätigkeiten und Hilfeleistungen im Bereich Büroorganisation – für einen effizienten und strukturierten Arbeitsalltag.",
    icon: Briefcase
  }];
  return <section className="py-16 px-4 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Vier Leistungsbereiche – ein Partner
          </h2>
          <p className="text-base lg:text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Münsterland Industrieservice bietet Ihnen vielseitige Dienstleistungen im Münsterland – von Flächenreinigung über Hausmeisterservice und Gartenpflege bis zu Büroorganisation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="border border-border shadow-soft hover-lift bg-muted-light">
                <CardHeader>
                  <div className="flex items-center gap-3 mb-2">
                    <div className="p-2.5 bg-primary/10 rounded-lg">
                      <Icon className="size-6 text-primary" />
                    </div>
                    <CardTitle className="text-xl lg:text-2xl font-bold text-foreground">
                      {service.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}